import * as PROSPECTS_ACTION_TYPES from "./actionTypes"

// getLeads
export const getProspects = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECTS,
    payload: payload,
  }
}

// getLeadsSuccess
export const getProspectsSuccess = (leads, meta) => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECTS_SUCCESS,
    payload: leads,
    meta,
  }
}

// getLeadsError
export const getProspectsError = (error, meta) => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECTS_ERROR,
    payload: error,
    meta,
  }
}

// updateLead
export const updateProspect = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT,
    payload: payload,
  }
}

// updateLeadSuccess
export const updateProspectSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_SUCCESS,
    payload: lead,
  }
}

// updateLeadError
export const updateProspectError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_ERROR,
    payload: error,
  }
}

// getLeadById
export const getProspectById = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECT_BY_ID,
    payload: payload,
  }
}

// getLeadByIdSuccess
export const getProspectByIdSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECT_BY_ID_SUCCESS,
    payload: lead,
  }
}

// getLeadByIdError
export const getProspectByIdError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECT_BY_ID_ERROR,
    payload: error,
  }
}

// updateLeadDetails
export const updateProspectDetails = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_DETAILS,
    payload: payload,
  }
}

// updateLeadDetailsSuccess
export const updateProspectDetailsSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_DETAILS_SUCCESS,
    payload: lead,
  }
}

// updateLeadDetailsError
export const updateProspectDetailsError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_DETAILS_ERROR,
    payload: error,
  }
}

// addLeadHome
export const addProspectHome = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_HOME,
    payload: payload,
  }
}
// addLeadHomeSuccess
export const addProspectHomeSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_HOME_SUCCESS,
    payload: lead,
  }
}

// addLeadHomeError
export const addProspectHomeError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_HOME_ERROR,
    payload: error,
  }
}
// addLeadViolation
export const addProspectViolation = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VIOLATION,
    payload: payload,
  }
}

// addLeadViolationSuccess
export const addProspectViolationSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VIOLATION_SUCCESS,
    payload: lead,
  }
}

// addLeadViolationError
export const addProspectViolationError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VIOLATION_ERROR,
    payload: error,
  }
}

// addLeadRefund
export const addProspectRefund = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_REFUND,
    payload: payload,
  }
}

// addLeadRefundSuccess
export const addProspectRefundSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_REFUND_SUCCESS,
    payload: lead,
  }
}

// addLeadRefundError
export const addProspectRefundError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.ADD_PROSPECT_REFUND_ERROR,
    payload: error,
  }
}

// deleteLeadRefund
export const deleteProspectRefund = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_REFUND,
    payload: payload,
  }
}

// deleteLeadRefundSuccess
export const deleteProspectRefundSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_REFUND_SUCCESS,
    payload: lead,
  }
}

// deleteLeadRefundError
export const deleteProspectRefundError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_REFUND_ERROR,
    payload: error,
  }
}

// updateLeadRefund
export const updateProspectRefund = payload => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_REFUND,
    payload: payload,
  }
}

// updateLeadRefundSuccess
export const updateProspectRefundSuccess = lead => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_REFUND_SUCCESS,
    payload: lead,
  }
}

// updateLeadRefundError
export const updateProspectRefundError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_REFUND_ERROR,
    payload: error,
  }
}

export const getConsentInformationById = (payload) => ({
  type: PROSPECTS_ACTION_TYPES.GET_CONSENT_INFORMATION_BY_ID,
  payload: payload
})

export const getConsentInformationByIdSuccess = (payload) => ({
  type: PROSPECTS_ACTION_TYPES.GET_CONSENT_INFORMATION_BY_ID_SUCCESS,
  payload: payload
})

export const getConsentInformationByIdError = (error) => ({
  type: PROSPECTS_ACTION_TYPES.GET_CONSENT_INFORMATION_BY_ID_ERROR,
  payload: error
})

export const getProspectDetailReport = (payload, filename) => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECT_DETAILS_EXPORT,
    payload: payload,
    filename: filename,
  }
}

export const getProspectDetailReportSuccess = (lead, filename) => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECT_DETAILS_EXPORT_SUCCESS,
    payload: lead,
    filename: filename,
  }
}

export const getProspectDetailReportError = error => {
  return {
    type: PROSPECTS_ACTION_TYPES.GET_PROSPECT_DETAILS_EXPORT_ERROR,
    payload: error,
  }
}
